<div *ngIf="!loading" class="border border-1 shadow-sm rounded-lg p-3 mx-auto mt-3">
  <div class="mb-2">
    <p class="fs-md-22 mb-0">Search Trends Overview</p>
    <span class="text-muted">See whats being searched every day</span>
  </div>

  <div class="bg-light rounded-3 overflow-hidden p-1 p-md-3">
    <div class="container-fluid px-0">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3 mb-sm-0">
          <table class="table table-striped mb-0 bg-white rounded-3 shadow-sm overflow-hidden">
            <thead>
            <tr>
              <th style="width: 45px;" class="" scope="col">
                <mat-icon style="color: #F2C35B;" class="large">whatshot</mat-icon>
              </th>
              <th scope="col">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <span class="fw-bolder fs-md-24">Trending Searches</span>
                  <span class="ms-auto me-0 text-muted small">(Last 7 days)</span>
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let search of trendingSearches; let i = index; let last = last">
              <td class="py-3 text-center fw-bolder fs-md-18" style="width: 45px; white-space: nowrap;">{{ i + 1 }}</td>
              <td class="py-3 fw-bolder fs-md-18 ms-3">{{ search.search_term }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12 col-sm-6">
          <ng-container *ngFor="let metric of metrics">
            <div *ngIf="metric && metric.data.length > 0" class="mb-2 mb-md-3">
              <div class="bg-white rounded-3 overflow-hidden shadow-sm">
                <pla-metric-graph
                  [chartType]="metric.chartType"
                  [dataPoints]="metric.data"
                  [icon]="metric.icon"
                  [title]="metric.title"
                  [interaction]="metric.key"
                  [key]="metric.key"
                  [rgb]="metric.rgb"
                  [ordinalOptions]="metric.ordinalOptions"
                ></pla-metric-graph>
              </div>
            </div>
          </ng-container>

          <!-- -->
          <div
            class="bg-white rounded-3 overflow-hidden shadow-sm w-100 p-3 mt-0 d-flex align-items-stretch justify-content-between flex-column">
            <div class="d-flex align-items-center justify-content-start gap-2 mb-1">
              <mat-icon class="large">password</mat-icon>
              <p class="my-0 fs-md-19 lh-sm">Unique Searches</p>
            </div>
            <p class="fs-md-40 lh-sm my-0"><span class="fs-md-40 fw-bold sm"
                                                 [appCountUp]="uniqueSearches" [duration]="1000"></span>
              <span class="ms-2 lh-sm fs-md-16">searches</span></p>
          </div>

          <div class="mt-4">
            <p class="text-center d-block mx-auto w-75 fs-md-18 lh-sm">Use these metrics to spot demand trends, optimize listings, and respond to what buyers are searching for.</p>
          </div>

        </div>
      </div>

      <div class="row"><div class=" px-2 px-md-5"><div class="border-top border-1 my-4 mx-auto"></div></div></div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-0 mb-sm-0" *ngFor="let topSplitSearches of topSearches; let outerIndex = index;">
          <table class="table table-striped mb-0 bg-white rounded-3 shadow-sm overflow-hidden">
            <thead>
            <tr class="{{ outerIndex === 0 ? '' : 'd-none d-sm-table-row' }}">
              <th style="width: 45px;" class="" scope="col">
                <mat-icon style="color: #A73636;" class="large">leaderboard</mat-icon>
              </th>
              <th scope="col">
                <div class="w-100 d-flex align-items-center justify-content-between">
                  <p class="{{ outerIndex === 0 ? '' : 'd-none d-sm-block' }} my-0 fw-bolder fs-md-24 fs-mb-18">Top Searches <span class="fs-md-24 fs-mb-18 fw-bolder d-none d-sm-inline">({{ (topSearchesTableSize * outerIndex) + 1 }} - {{ topSearchesTableSize * (outerIndex + 1) }})</span></p>
                  <span class="{{ outerIndex === 0 ? '' : 'd-none d-sm-block' }} ms-auto me-0 text-muted small">(All Time)</span>
                </div>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let search of topSplitSearches; let i = index; let last = last">
              <td class="py-3 text-center fw-bolder fs-md-18" style="width: 45px; white-space: nowrap;">{{ (topSearchesTableSize * outerIndex) + (i + 1) }}</td>
              <td class="py-3 fw-bolder fs-md-18 ms-3">{{ search.search_term }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
